'use strict'

import AmpliVarStatStore from './store/AmpliVarStatStore'

import AmpliVarStatListView from './views/AmpliVarStatListView'


export default class AmpliVarStatPlugin {

	constructor() {
		console.debug("AmpliVarStat plugin constructor()")

		this._router_routes = [
			{
				path: '/ampli_var_stat',
				component: AmpliVarStatListView,
				beforeEnter: this.buildHandler_requireAuthenticated(),
			},]
	}

	install(Vue, subsite, router, store) {
		console.debug("AmpliVarStat plugin install()")

		this._subsite = subsite
		this._router = router
		this._store = store

		for (let route_i = 0; route_i < this._router_routes.length; route_i++) {
			const route = this._router_routes[route_i]
			this._router.addRoute(route)
		}

		const ampli_var_stat_store = new AmpliVarStatStore(this._subsite)

		this._store.registerModule('ampli_var_stat', ampli_var_stat_store)

		let k = 7
	}

	/**
	 * создает и возвращает обработчик,
	 * в котором доступен this объект плагина
	 * (с объектами _store)
	 */
	buildHandler_requireAuthenticated() {

		return function (to, from, next) {
			this._store.dispatch('auth/initialize') // здесь вызываем action (действие) testLogin модуля auth store.auth.initialize()
				.then(() => {
					if (!this._store.getters['auth/isAuthenticated']) {
						next({path: '/login?from=' + to.path});
					} else {
						next();
					}
				});
		}.bind(this)
	}

	init(root, ssdContext) {
		console.debug("AmpliVarStat plugin init()")
	}

	use(Service) {
		console.debug("AmpliVarStat plugin use()")
	}

	created() {
		console.debug('AmpliVarStat plugin created() ')
	}
}
